// import { useTheme } from "styled-components";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    // const { isDark } = useTheme();
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 20 20"
    }, props), {
        children: /*#__PURE__*/ _jsx("g", {
            id: "页面-1",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ _jsx("g", {
                id: "通用页面2",
                transform: "translate(-1044.000000, -505.000000)",
                fill: "#C3C9D0",
                fillRule: "nonzero",
                children: /*#__PURE__*/ _jsx("g", {
                    id: "编组-6",
                    transform: "translate(700.000000, 270.000000)",
                    children: /*#__PURE__*/ _jsx("g", {
                        id: "编组-4",
                        transform: "translate(123.000000, 197.000000)",
                        children: /*#__PURE__*/ _jsx("g", {
                            id: "编组-5",
                            transform: "translate(35.000000, 38.000000)",
                            children: /*#__PURE__*/ _jsxs("g", {
                                id: "rotate-right-outlined",
                                transform: "translate(186.000000, 0.000000)",
                                children: [
                                    /*#__PURE__*/ _jsx("rect", {
                                        id: "矩形",
                                        opacity: "0",
                                        x: "0",
                                        y: "0",
                                        width: "20",
                                        height: "20"
                                    }),
                                    /*#__PURE__*/ _jsx("path", {
                                        d: "M9.38476562,4.90625 C9.63867187,4.875 9.890625,4.859375 10.1425781,4.85742188 L10.1425781,6.10546875 C10.1425781,6.23242188 10.2890625,6.30273438 10.3886719,6.22460938 L12.890625,4.25 C12.96875,4.1875 12.96875,4.0703125 12.890625,4.00976562 L10.390625,2.03710937 C10.2910156,1.95898437 10.1445312,2.02929687 10.1445312,2.15625 L10.140625,3.40625 C7.82421875,3.41601562 5.53515625,4.44921875 3.99609375,6.41796875 C2.63671875,8.16015625 2.12695312,10.296875 2.41210937,12.3242188 L3.875,12.3242188 C3.85742187,12.2207031 3.84179687,12.1152344 3.828125,12.0097656 C3.72851562,11.1875 3.78710937,10.3671875 4.00195312,9.57226563 C4.22460937,8.74804688 4.60742187,7.98828125 5.13671875,7.31054688 C5.66796875,6.6328125 6.31445312,6.07617188 7.05859375,5.6640625 C7.78125,5.26171875 8.56054687,5.0078125 9.38476562,4.90625 Z M17.1875,8.1640625 L6.875,8.1640625 C6.52929688,8.1640625 6.25,8.44335938 6.25,8.7890625 L6.25,16.875 C6.25,17.2207031 6.52929688,17.5 6.875,17.5 L17.1875,17.5 C17.5332031,17.5 17.8125,17.2207031 17.8125,16.875 L17.8125,8.7890625 C17.8125,8.44335938 17.5332031,8.1640625 17.1875,8.1640625 Z M16.328125,16.015625 L7.734375,16.015625 L7.734375,9.6484375 L16.328125,9.6484375 L16.328125,16.015625 Z",
                                        id: "形状"
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    }));
};
export default Icon;
